import { getLocalStore, setLocalStore } from '../util/Helpers';
import { DEMO_MODE } from '../util/Constants';

import config from './../config.json'

export const conf = {
    "env": config['env'],
    "token": config['demo']['token'],
    "endpoint": config['api']['endpoint'],
    "currency": config['currency']
}

const Config = () => {

    const setMode = () => {
        const getMode = getLocalStore(DEMO_MODE)
        if(!getMode)
        {
            setLocalStore(DEMO_MODE, config['demo']['status'])
        }
    }

    if(conf['env']!=='production'||conf['env']!=='staging')
    {
        setMode()
    }

}

export default Config;